// TptAI AG1 Testimonials Section JavaScript
// Handles custom interactions for the testimonials carousel

class TptAIAG1Testimonials {
  constructor() {
    this.init();
  }

  init() {
    this.setupTestimonialCards();
    this.setupNavigationInteractions();
  }

  setupTestimonialCards() {
    const cards = document.querySelectorAll('.tptai-ag1-testimonials_card');
    
    cards.forEach(card => {
      card.addEventListener('mouseenter', this.handleCardHover.bind(this));
      card.addEventListener('mouseleave', this.handleCardLeave.bind(this));
    });
  }

  setupNavigationInteractions() {
    const navButtons = document.querySelectorAll('.tptai-ag1-testimonials_nav');
    
    navButtons.forEach(button => {
      button.addEventListener('click', this.handleNavClick.bind(this));
      button.addEventListener('keydown', this.handleNavKeydown.bind(this));
    });
  }

  handleCardHover(event) {
    const card = event.currentTarget;
    card.style.transform = 'translateY(-0.25em)';
    card.style.boxShadow = '0 0.5em 1em rgba(0, 0, 0, 0.1)';
  }

  handleCardLeave(event) {
    const card = event.currentTarget;
    card.style.transform = 'translateY(0)';
    card.style.boxShadow = 'none';
  }

  handleNavClick(event) {
    const button = event.currentTarget;
    
    // Add click animation
    button.style.transform = 'translateY(-50%) scale(0.95)';
    
    setTimeout(() => {
      button.style.transform = 'translateY(-50%) scale(1)';
    }, 150);
  }

  handleNavKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.handleNavClick(event);
    }
  }
}

// Initialize the testimonials functionality when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new TptAIAG1Testimonials();
});

// Re-initialize on theme section updates
document.addEventListener('shopify:section:load', () => {
  new TptAIAG1Testimonials();
});